import type { ActiveTemplateCategoryMeta } from '../../api/types';

/**
 * Per-category progress for the tabs. The completion counts now come straight
 * from the template outline (`fieldsFilled` / `totalFields`), so this is a thin
 * adapter rather than a field scan. `hasSavedValues` feeds the page's
 * completion metric (categories with at least one saved value).
 */
export interface DerivedCategory {
  filledCount: number;
  totalFields: number;
  hasSavedValues: boolean;
}

/** Adapt an outline category meta into the tab's progress shape. */
export function deriveCategoryStatus(
  meta: ActiveTemplateCategoryMeta,
): DerivedCategory {
  return {
    filledCount: meta.fieldsFilled,
    totalFields: meta.totalFields,
    hasSavedValues: meta.fieldsFilled > 0,
  };
}
